import { render, staticRenderFns } from "./moneyBoxesTable.vue?vue&type=template&id=d2cb1384&"
import script from "./moneyBoxesTable.vue?vue&type=script&lang=ts&"
export * from "./moneyBoxesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports